import React from 'react';
import { Link } from 'react-router-dom';

const SecondaryButton = ({ children, to, href, className = '', ...props }) => {
  if (to) {
    return (
      <Link to={to} className={`button button-secondary ${className}`.trim()} {...props}>
        {children}
      </Link>
    );
  }

  return (
    <a href={href} className={`button button-secondary ${className}`.trim()} {...props}>
      {children}
    </a>
  );
};

export default SecondaryButton;
